/**
* AppController
* @namespace gplans.layout.controllers
*/
(function () {
  'use strict';AppController.$inject = ["$analytics", "$location", "$rootScope", "$scope", "$state", "$window", "$cookies", "$uibModal", "AppVersionChanged", "Authentication", "DateTime", "Intercom", "MealPaused", "Profile", "User"];

  angular.
  module('gplans.layout.controllers').
  controller('AppController', AppController);

  AppController.$inject = [
  '$analytics',
  '$location',
  '$rootScope',
  '$scope',
  '$state',
  '$window',
  '$cookies',
  '$uibModal',
  'AppVersionChanged',
  'Authentication',
  'DateTime',
  'Intercom',
  'MealPaused',
  'Profile',
  'User'];


  /**
           * @namespace AppController
           */
  function AppController(
  $analytics,
  $location,
  $rootScope,
  $scope,
  $state,
  $window,
  $cookies,
  $uibModal,
  AppVersionChanged,
  Authentication,
  DateTime,
  Intercom,
  MealPaused,
  Profile,
  User)
  {
    var vm = this;
    var modalInstance, modalShown;

    activate();

    function appVersionSync() {
      AppVersionChanged.init();
    }

    /**
      * @name fbConnect
      * @desc Connect the logged in user to facebook
      * @memberOf gplans.layout.controllers.AppController
      */
    function fbConnect() {
      FB.login(function (res) {
        if (res.status === 'connected') {
          Authentication.facebookConnect(res.authResponse.accessToken);
        }
      }, { scope: 'email' });
    }

    /**
      * @name logout
      * @desc Log the user out
      * @memberOf gplans.layout.controllers.AppController
      */
    function logout() {
      Authentication.logout();
    }

    /**
      * @name pageTitle
      * @desc Update the Page Title at the top of the page
      * @memberOf gplans.layout.controllers.AppController
      */
    function pageTitle() {
      $rootScope.pageTitle = $state.current.title;
      $rootScope.loginPage = $state.current.loginPage;
      $rootScope.pageDescription = $state.current.description;
      if ('undefined' !== typeof ga) {
        ga('send', 'pageview', $location.path());
      }
      if ('function' === typeof hj) {
        hj('vpv', $location.path());
      }
    }

    /**
       * @name stateVisit
       * @desc do smth. on state change or initial visit
       * @memberOf gplans.layout.controllers.AppController
       */
    function stateVisit() {
      if ($state.current.name === 'gplansApp.dashboard.measurements') {
        $analytics.eventTrack('Visited /app/measurements');
      }
      if ($state.current.name === 'gplansApp.dashboard.weekplan') {
        $analytics.eventTrack('Visited /app/weekplan');
      }
      if ($state.current.name === 'gplansApp.dashboard.resources') {
        $analytics.eventTrack('Visited /app/resources');
      }
    }

    /**
       * @name statePreVisit
       * @desc do smth. before state changes
       * @memberOf gplans.layout.controllers.AppController
       * @returns {boolean} – false if we want to prevent state transition
       */
    var redirectionInProcess = false;
    function statePreVisit() {

      if (redirectionInProcess) {
        redirectionInProcess = false;
        return true;
      }

      if ($rootScope.user.last_checkin.day > 7) {
        if ($state.current.name != 'gplansApp.dashboard.checkin')
        redirectionInProcess = true;
        $state.go('gplansApp.dashboard.checkin');
        return false;
      }

      var searchObject = $location.search();
      if ($state.current.name === 'gplansApp.dashboard.checkin' &&
      $rootScope.user.last_checkin.day < 8 &&
      !searchObject.force) {
        redirectionInProcess = true;
        $state.go('gplans.userConsole');
        return false;
      }

      return true;
    }

    /**
      * @name activate
      * @desc Actions to be performed when this controller is instantiated
      * @memberOf gplans.layout.controllers.AppController
      */
    function activate() {
      appVersionSync();

      $rootScope.logout = logout;
      $rootScope.fbConnect = fbConnect;
      $rootScope.user = User;
      // $rootScope.user = typeof gplans !== 'undefined' ? gplans.User : null;

      pageTitle();
      if ($rootScope.user) {
        statePreVisit();
        stateVisit();
        if ($rootScope.user && parseInt($rootScope.user.one_time_payment) > 0) {
          $state.go('base.store_one_time_payment', {}, { reload: true });
          return;
        }

        if ($rootScope.user && $rootScope.user.meal_plan && $rootScope.user.meal_plan.id) {
          // fetchMeals();
        } else {
          if (!$rootScope.user.user_survey_id) {
            $state.go('base.select_meta', {}, { reload: true });
            return;
          }
          if (!$rootScope.user.subscription_plan) {
            $state.go('base.store', {}, { reload: true });
            return;
          }
        }
        $rootScope.initDone = 1;
      }

      $rootScope.$on('$stateChangeSuccess', function (event, current, previous) {
        pageTitle();
        stateVisit();
        angular.element('.nav-toggleable-sm.collapse').removeClass('in');
      });

      $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
        if (!statePreVisit()) {
          event.preventDefault();
        }
      });

      $scope.$watch('user', handleUserCheked);

      function handleUserCheked(newVal, oldVal) {
        if (!$rootScope.user) {
          if ($state.current.authenticated) {
            // check if we are already authenticated by server
            Authentication.check().then(
            function (res) {
              $window.location.reload();
            },
            // if not – go to login
            function (err) {
              $state.go('login', {}, { reload: true });
            });

          }
          return;
        }
        if ($rootScope.user.last_checkin) {
          // If they have never bought a plan but have a checkin kick to checkout
          if (!$rootScope.user.subscription_plan) {
            $state.go('base.store', {}, { reload: true });
            return;
          }

          var d = DateTime.now();
          var checkinDate = DateTime.parseDate($rootScope.user.last_checkin.created_at);
          $rootScope.user.last_checkin.day = DateTime.dayDiff(checkinDate, DateTime.parseDate(d.toISOString())) + 1;
          // here we should check if last_checkin.day == mealPlanPaused, if not –> update checkin date with a new value
          if (MealPaused && MealPaused != $rootScope.user.last_checkin.day) {
            var new_date = new Date($rootScope.user.last_checkin.created_at);
            new_date.setDate(new_date.getDate() + ($rootScope.user.last_checkin.day - MealPaused));
            $rootScope.user.last_checkin.created_at = new_date;
            Profile.updateCheckin($rootScope.user.last_checkin);
            $rootScope.user.last_checkin.day = MealPaused;
          }

          statePreVisit();

          // Intercom.bootOrUpdate($rootScope.user); // we boot on all pages!
          // if we're booted first time, send plan to Intercom
          Profile.getMisc('planSentToIntercom').then(
          // already sent
          function (res) {console.log(res);},
          // not sent
          function () {
            Intercom.bootOrUpdate($rootScope.user); // this will update user props
            // TODO: encapsulate into separate Sentry service
            var userData = $rootScope.user;
            var props = {
              id: userData.intercom_id };

            if (userData.age) props.age = userData.age;
            if (userData.username) props.username = userData.username;
            if (userData.gender) props.gender = userData.gender;
            if (userData.email) props.email = userData.email;
            props.name = '';
            if (userData.first_name) props.name += userData.first_name;
            if (props.name && userData.last_name) props.name += ' ';
            if (userData.last_name) props.name += userData.last_name;
            if (userData.date_joined) props.created_at = Math.round(new Date(userData.date_joined).getTime() / 1000);
            if (userData.subscription_plan && userData.subscription_plan.name) props.plan = userData.subscription_plan.name;
            if (window.Raven) window.Raven.setUserContext(props);

            Profile.createMisc({ key: 'planSentToIntercom', value: '1' });
          });
        } else {// there is no checkin yet
          // TODO: we should also stop nested controllers to be loaded (mealplan controller)
          $state.go('survey.question', { surveyId: 1, question: 1 }, {}, { reload: true });
          return;
        }
      }

      $scope.$on('AUTH_EVENTS:notAuthenticated', handleUnauthenticated);
      $scope.$on('AUTH_EVENTS:forbidden', handleUnauthenticated);

      function handleUnauthenticated(event) {
        Authentication.logout();
        $state.go('login', {}, { reload: true });
        console.log('Sorry, You have to login again.');
      }
    }

    function _fireModal() {
      if (!modalShown) {
        modalShown = true;
        modalInstance = $uibModal.open({
          animation: true,
          templateUrl: 'templates/dashboard/app-version-changed.modal.html',
          controller: 'AppVersionChangedModalInstanceCtrl',
          controllerAs: 'vm',
          showClose: false,
          closeByEscape: false,
          closeByDocument: false,
          backdrop: 'static',
          keyboard: false });

        modalInstance.result.then(function (res) {
          console.log(res);
          modalShown = false;
        }, function () {
          console.log('Cancelled');
          modalShown = false;
        });
      }
    }
  }
})();